import React, { ReactElement, Suspense } from "react";
import * as Sentry from "@sentry/react";
import { HashRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./routes/home";
import { useMount } from "ahooks";
import useHostLoginGuard from "@/hooks/useHostLoginGuard";

const Record = React.lazy(
  () => import(/* webpackChunkName: "Record" */ "./routes/record"),
);
const Privilege = React.lazy(
  () => import(/* webpackChunkName: "Privilege" */ "./routes/privilege"),
);
const Rules = React.lazy(
  () => import(/* webpackChunkName: "Rules" */ "./routes/rules"),
);
const GrowthDetail = React.lazy(
  () => import(/* webpackChunkName: "GrowthDetail" */ "./routes/growth-detail"),
);
const CouponRecord = React.lazy(
  () => import(/* webpackChunkName: "CouponRecord" */ "./routes/coupon-record"),
);
const ExchangeRights = React.lazy(
  () =>
    import(/* webpackChunkName: "ExchangeRights" */ "./routes/exchange-rights"),
);
const VipGoods = React.lazy(
  () => import(/* webpackChunkName: "VipGoods" */ "./routes/vip-goods"),
);

const App = (): ReactElement => {
  useMount(() => {
    document.querySelector("._initial_full_page_loading_")?.remove();
    Sentry.captureMessage("App Mounted");
  });
  // 宿主未登录守卫：H5 侧跳转（goToPage / goToPageV2）拼的 appId 恒为空，会绕过小程序的
  // 登录门禁把本页在未登录状态下打开，此时 webview cookie 里还是退登前的旧 uid
  const hostLoginBlocked = useHostLoginGuard();
  if (hostLoginBlocked) {
    return <></>;
  }
  return (
    <Router>
      <Suspense fallback={null}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/vip-goods" element={<VipGoods />} />
          <Route path="/record" element={<Record />} />
          <Route path="/privilege" element={<Privilege />} />
          <Route path="/rules" element={<Rules />} />
          <Route path="/growth-detail" element={<GrowthDetail />} />
          <Route path="/coupon-record" element={<CouponRecord />} />
          <Route path="/exchange-rights" element={<ExchangeRights />} />
        </Routes>
      </Suspense>
    </Router>
  );
};

export default App;
